import React, { useCallback, useEffect, useMemo, useState } from "react";

import { Col, Row, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import ScrollBar from "react-perfect-scrollbar";
import { MdKeyboardArrowRight } from "react-icons/md";
import { dashboardLinkList } from "../Constants";
import { WidgetCard } from "app/Components/EhsDashboard/Global/Widgets";
import {
  IS_USER_SITE_MINES,
  IS_USER_SITE_RO,
} from "../_healthSafetyEnvironment/IncidentManagement/Helper";
import {
  chartDataHO,
  chartDataMINE,
  chartDataRO,
  WigetListHO,
  WigetListMINE,
  WigetListRO,
} from "./CompanyDashboardConstant";
import { GlobalDashboardService } from "app/_services/GlobalDashboardService/GlobalDashboardService";
import {
  BarChartCard,
  BasicBarChartWithLabelCard,
  MultipleBarChartCard,
  StackBarChartCard,
} from "app/Components/ChartCard/ChartCard";
import PieChartWithModal from "app/Components/PieChartWithModal/PieChartWithModal";
import {
  barChartDataFormat,
  BasicBarChartWithLabelDataFormat,
  multiLineChartDataFormat,
  pieChartDataWithModal,
  stackChartDataFormat,
} from "./Comman/config";
import { isArray } from "lodash";
import DropdownMenu from "react-bootstrap/DropdownMenu";
import DropdownToggle from "react-bootstrap/DropdownToggle";
import { useDispatch, useSelector } from "react-redux";
import ScreenOption from "./ScreenOption";
import { useSite } from "app/_helpers/hooks";
import { getAllSites, getAllSitesWithAccess } from "app/_services/ehs/ehsSiteServices";
import moment from "moment";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";
const Dashboard = () => {
  const [sites, sitesOption] = useSite();
  const [widgetData, setWidgetData] = useState(() =>
    IS_USER_SITE_MINES() ? WigetListMINE : IS_USER_SITE_RO() ? WigetListRO : WigetListHO
  );
  const [chartData, setChartData] = useState(() =>
    IS_USER_SITE_MINES() ? chartDataMINE : IS_USER_SITE_RO() ? chartDataRO : chartDataHO
  );

  const [allSite, setAllSite] = useState([]);
  const [haveAccessToSite, setHaveAccessToSite] = useState([]);
  const [currentSelectedSite, setCurrentSelectedSite] = useState({});
  const [zoomActive, setZoomActive] = useState(false);
  const [loading, setLoading] = useState(true);
  // const siteId = useSelector((state) => state.userData?.siteIds);

  const globalSelectedSiteId = useSelector((state) => state.userData?.siteIds);
  // console.log("//*/*/globalSelectedSiteId", globalSelectedSiteId);
  useEffect(() => {
    getAllSitesWithAccess().then((res) => {
      setAllSite(res?.data?.availableSites);
    });
  }, []);

  useEffect(() => {
    const getSiteData = allSite?.find((d) => d.id == globalSelectedSiteId);
    // pageValueFun(getSiteData?.siteType == 3 ? 2 : 1);
    const haveAccessToSiteArray =
      getSiteData?.siteType == 1
        ? allSite?.map((d) => {
            return d.id;
          })
        : getSiteData?.siteType == 2
        ? allSite
            ?.filter((d) => {
              if (d.id == globalSelectedSiteId || d.parentSiteId == globalSelectedSiteId)
                return d.id;
            })
            .map((d) => {
              return d.id;
            })
        : getSiteData?.siteType == 3
        ? allSite
            ?.filter((d) => {
              if (d.id == globalSelectedSiteId) return d.id;
            })
            .map((d) => {
              return d.id;
            })
        : [];

    setCurrentSelectedSite(getSiteData);
    setHaveAccessToSite(haveAccessToSiteArray);
  }, [allSite, globalSelectedSiteId]);

  const dashboardData = useCallback(async () => {
    let obj = {
      startDate: "",
      endDate: "",
      siteId: globalSelectedSiteId ? haveAccessToSite : null,
    };
    // console.log("/*/*/**/*siteType", (!globalSelectedSiteId), globalSelectedSiteId ? currentSelectedSite?.siteType : 222, globalSelectedSiteId ? currentSelectedSite?.siteType : IS_USER_SITE_MINES() ? 3 : IS_USER_SITE_RO() ? 2 : 1);
    const siteType =
      (isArray(globalSelectedSiteId) && globalSelectedSiteId?.length > 0) ||
      (!isArray(globalSelectedSiteId) &&
        globalSelectedSiteId &&
        currentSelectedSite &&
        currentSelectedSite?.siteType)
        ? currentSelectedSite?.siteType
        : IS_USER_SITE_MINES()
        ? 3
        : IS_USER_SITE_RO()
        ? 2
        : 1;
    // console.log("/**//*/*/*//dashboardBySiteType", IS_USER_SITE_MINES(), currentSelectedSite, siteType);
    // console.log("/*/*/**/*siteType", siteType, globalSelectedSiteId, currentSelectedSite);
    const dashboardBySiteType =
      siteType === 3
        ? chartDataMINE
        : siteType === 2
        ? chartDataRO
        : siteType === 1
        ? chartDataHO
        : [];
    const widgetBySiteType =
      siteType === 3
        ? WigetListMINE
        : siteType === 2
        ? WigetListRO
        : siteType === 1
        ? WigetListHO
        : [];
    let checkUserType = siteType === 3 ? "mine" : siteType === 2 ? "ro" : "ho";
    //let checkUserType = IS_USER_SITE_MINES() ? "mine" : IS_USER_SITE_RO() ? "ro" : "ho";
    // console.log("/*/*/**/*siteType", siteType);
    let response = await GlobalDashboardService.defaultDashboard(obj, checkUserType);
    if (response && response.status && response.data) {
      const dashboardData = response.data;

      setChartData((prev) => {
        return dashboardBySiteType?.map((d) => ({
          ...d,
          value:
            d.type === "bar" || d.type === "line"
              ? barChartDataFormat(dashboardData?.[d.value])
              : d.type === "stack"
              ? stackChartDataFormat(dashboardData[d.value])
              : d.type === "multiLine"
              ? multiLineChartDataFormat(dashboardData[d.value])
              : d?.type == "barWithLabel"
              ? BasicBarChartWithLabelDataFormat(dashboardData[d?.value])
              : pieChartDataWithModal(dashboardData?.[d.value]),
        }));
      });
      setWidgetData((prev) => {
        return widgetBySiteType.map((d) => ({
          ...d,
          value: dashboardData?.[d.key],
        }));
      });
    }
    setLoading(false);
  }, [currentSelectedSite, globalSelectedSiteId, haveAccessToSite]);

  useEffect(() => {
    dashboardData();
  }, [dashboardData]);

  return (
    <div className="dashBoardContainer">
      {/* <GlobalDashboardSidebar history={history} /> */}
      <Row>
        <Col lg={12}>
          <Row className="">
            <Col lg={12} className="widgetContainer mt-3">
              <WidgetCard widgetData={widgetData} className={"col"} />
            </Col>
          </Row>
          {!loading ? (
            <Row className="screenOne">
              {chartData?.map((item, idx) => (
                <Col
                  lg={item?.isMines ? 12 : 6}
                  key={idx}
                  id={"main_" + idx}
                  className="mb-4 pb-2"
                >
                  {item.type === "line" || item.type === "multiLine" ? (
                    <MultipleBarChartCard
                      id={"main_" + idx}
                      title={item?.name}
                      yAxisName={item?.yAxisName}
                      xAxisName={item?.xAxisName}
                      category={item?.value?.categoryData?.map((d) =>
                        moment(d, "YYYY-MM").format("MMM YYYY")
                      )}
                      seriesData={
                        isArray(item?.value?.data) &&
                        item?.value?.data.map((d) => ({
                          ...d,
                          type: item.type === "multiLine" ? d.type : item.type,
                        }))
                      }
                    />
                  ) : item.type === "barWithLabel" ? (
                    <BasicBarChartWithLabelCard
                      id={"main_" + idx}
                      title={item?.name}
                      yAxisName={item?.yAxisName}
                      xAxisName={item?.xAxisName}
                      customeTool={item?.customeTool}
                      customToolTip={item?.value?.customToolTip}
                      category={item?.value?.categoryData}
                      seriesData={item?.value?.data}
                    />
                  ) : item.type === "stack" ? (
                    <StackBarChartCard
                      id={"main_" + idx}
                      title={item?.name}
                      yAxisName={item?.yAxisName}
                      xAxisName={item?.xAxisName}
                      categoryData={item?.value?.categoryData}
                      seriesData={item?.value?.data}
                    />
                  ) : (
                    <PieChartWithModal
                      id={"main_" + idx}
                      title={item.title}
                      seriesData={item?.value || []}
                      customLabelFalse={true}
                      isCustomLegend={true}
                      scrollLegend={(item.isScroll && !zoomActive) || false}
                      setZoomActive={setZoomActive}
                      zoomActive={zoomActive}
                    />
                  )}
                </Col>
              ))}
            </Row>
          ) : (
            <NetZeroLoader addZIndex={true} />
          )}

          <Dropdown className="dashboardListToggle">
            <DropdownToggle variant="link" className="toggle-hidden">
              <div className="accordionTitle">
                Dashboard List <MdKeyboardArrowRight />
              </div>
            </DropdownToggle>
            <DropdownMenu>
              {Object?.entries(dashboardLinkList).map((item) => (
                <div className="m-2">
                  <Link to={`/${item[0]}/dashboard`} style={{ color: "#262433" }}>
                    {item[1]}
                  </Link>
                </div>
              ))}
            </DropdownMenu>
          </Dropdown>
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;
